import { put, takeLatest, select } from 'redux-saga/effects'
import * as Eff from 'redux-saga/effects' // tslint:disable-line:no-duplicate-imports
import toastr from 'toastr'
import 'toastr/build/toastr.css'

import Logger from '@Utils/Logger'
import { IAction, ISuccessResponse } from '@Root/types'

import {
  fetchGuidelines,
  fetchGuidelinesSuccess,
  fetchGuidelinesFailure,
  createGuidelineSuccess,
  createGuidelineFailure,
  updateGuidelineSuccess,
  updateGuidelineFailure,
  deleteGuidelineSuccess,
  deleteGuidelineFailure,
  updateDefaultGuidelineSuccess,
  updateDefaultGuidelineFailure,
  deleteDefaultGuidelineSuccess,
  deleteDefaultGuidelineFailure,
} from './actions'

import {
  GuidelineActionTypes,
  IFetchGuidelinesSuccessResponseBody,
  ICreateGuidelinePayload,
  IUpdateGuidelinePayload,
  IDeleteGuidelinePayload,
  IUpdateDefaultGuidelinePayload,
  IDeleteDefaultGuidelinePayload,
  IFetchGuidelinesPayload,
} from './types'

import * as API from './api'

const call: any = Eff.call

function* fetchGuidelinesSaga(action: IAction<IFetchGuidelinesPayload>) {
  try {
    const response: ISuccessResponse<IFetchGuidelinesSuccessResponseBody> = yield call(API.fetchGuidelines, action.payload)
    const payloadResponse = response.data
    yield put(fetchGuidelinesSuccess(payloadResponse))
  } catch (e) {
    Logger.error(e, 'Guidelines could not be loaded')
    yield put(fetchGuidelinesFailure())
  }
}

function* createGuidelineSaga(action: IAction<ICreateGuidelinePayload>) {
  try {
    const { payload } = action
    yield call(API.createGuideline, payload)
    yield put(createGuidelineSuccess())
    toastr.success('', 'Guideline created')
    yield put(fetchGuidelines({ workspaceId: payload.workspaceId }))
  } catch (e) {
    Logger.error(e, 'Guideline could not be created')
    yield put(createGuidelineFailure())
  }
}

function* updateGuidelineSaga(action: IAction<IUpdateGuidelinePayload>): Generator<any, any, any> {
  try {
    const { payload } = action
    yield call(API.updateGuideline, payload)
    yield put(updateGuidelineSuccess())
    if (payload.prompt || payload.parameters) {
      toastr.success('', 'Changes saved')
    } else {
      toastr.success('', 'Name saved')
    }
    const state = yield select()
    yield put(fetchGuidelines({ workspaceId: state.workspaces.currentWorkspaceId }))
  } catch (e) {
    Logger.error(e, 'Changes could not be saved')
    yield put(updateGuidelineFailure())
  }
}

function* deleteGuidelineSaga(action: IAction<IDeleteGuidelinePayload>): Generator<any, any, any> {
  try {
    yield call(API.deleteGuideline, action.payload)
    yield put(deleteGuidelineSuccess())
    toastr.success('', 'Guideline deleted')
    const state = yield select()
    yield put(fetchGuidelines({ workspaceId: state.workspaces.currentWorkspaceId }))
  } catch (e) {
    Logger.error(e, 'Guideline could not be deleted')
    yield put(deleteGuidelineFailure())
  }
}

function* updateDefaultGuidelineSaga(action: IAction<IUpdateDefaultGuidelinePayload>) {
  try {
    const { payload } = action
    yield call(API.updateDefaultGuideline, payload)
    yield put(updateDefaultGuidelineSuccess())
    if (payload.hasSavedNameOnly) {
      toastr.success('', 'Name saved')
    } else {
      toastr.success('', 'Changes saved')
    }
    yield put(fetchGuidelines({ workspaceId: payload.workspaceId }))
  } catch (e) {
    Logger.error(e, 'Changes could not be saved')
    yield put(updateDefaultGuidelineFailure())
  }
}

function* deleteDefaultGuidelineSaga(action: IAction<IDeleteDefaultGuidelinePayload>) {
  try {
    const { payload } = action
    yield call(API.deleteDefaultGuideline, payload)
    yield put(deleteDefaultGuidelineSuccess())
    toastr.success('', 'Guideline deleted')
    yield put(fetchGuidelines({ workspaceId: payload.workspaceId }))
  } catch (e) {
    Logger.error(e, 'Guideline could not be deleted')
    yield put(deleteDefaultGuidelineFailure())
  }
}

function* guidelineSagas() {
  yield takeLatest(GuidelineActionTypes.FETCH_GUIDELINES, fetchGuidelinesSaga)
  yield takeLatest(GuidelineActionTypes.CREATE_GUIDELINE, createGuidelineSaga)
  yield takeLatest(GuidelineActionTypes.UPDATE_GUIDELINE, updateGuidelineSaga)
  yield takeLatest(GuidelineActionTypes.DELETE_GUIDELINE, deleteGuidelineSaga)
  yield takeLatest(GuidelineActionTypes.UPDATE_DEFAULT_GUIDELINE, updateDefaultGuidelineSaga)
  yield takeLatest(GuidelineActionTypes.DELETE_DEFAULT_GUIDELINE, deleteDefaultGuidelineSaga)
}

export default guidelineSagas
